var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8,8.4l-8,2.7c-.2,0-.4.3-.4.5s0,.5.3.6l3.2,1.9,1.9,3.2c.1.2.4.3.6.3s.5-.2.5-.4l2.7-8c0-.2,0-.5-.2-.7s-.4-.2-.7-.2ZM12.2,15.5l-1.3-2.1c0,0-.1-.2-.2-.2l-2.1-1.3,5.4-1.8-1.8,5.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7,11.3h-2.7c-.3-4-3.4-7.2-7.4-7.7V1c0-.4-.3-.7-.7-.7s-.7.3-.7.7v2.7c-4.2.2-7.6,3.5-8,7.7H1c-.4,0-.7.3-.7.7s.3.7.7.7h2.4c.3,4.2,3.7,7.5,8,7.7v2.7c0,.4.3.7.7.7s.7-.3.7-.7v-2.7c4-.4,7.1-3.7,7.4-7.7h2.7c.4,0,.7-.3.7-.7s-.3-.7-.7-.7ZM16.7,17c-1.3,1.3-3,2.1-5,2.1-2,0-3.7-.8-5-2.1-1.3-1.3-2.1-3-2.1-5,0-2,.8-3.7,2.1-5,1.3-1.3,3-2.1,5-2.1,2,0,3.7.8,5,2.1,1.3,1.3,2.1,3,2.1,5,0,2-.8,3.7-2.1,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/navigator.9c5619dcc908013f9603473df5041fbc.svg";
export { ForwardRef as ReactComponent };